export const $APP_NAME = "Mapit";
export const $APP_NAME_LONG = "Mapit - Last-Mile Solutions";
export const $__DEV__ = false

const getServerUrl = (env = "MERCHANT") => {
    if (env === "OTO") {
        return "https://map-it-oto-4b4a286d0f96.herokuapp.com"
    } else if (env === "STAGING") {
        return "https://mapit-staging.herokuapp.com"
    } else if (env === "MERCHANT") {
        return "https://merchant-map-it.herokuapp.com"
    } else if (env === "ENHANCEMENT") {
        return "https://mapit-enhancement.herokuapp.com"
    } else if (env === "PRODUCTION") {
        return "https://backend.mapit.sa"
    }
}

export const $BASE_URL = process.env.REACT_APP_ENV === "locale" ? getServerUrl() : process.env.REACT_APP_SERVER_URL;

export const ROLES = {
    admin: "ADMIN",
    merchant: "BASIC",
    shippingCompany: "SHIPPING_COMPANY",
    warehouseGuard: "WAREHOUSE_GUARD",
    driver: "DRIVER",
    freelanceDriver: "FREELANCE_DRIVER",
}
export const ROLE_PATH = {
    ADMIN: "admin",
    BASIC: "merchant",
    SHIPPING_COMPANY: "merchant",
    MERCHANT: "merchant",
    merchant: "merchant",
    FREELANCE_DRIVER: "freelance_driver/tasks/zones?status=TASK_ASSIGNED_TO_DRIVER_FOR_PICK_UP",
    WAREHOUSE_GUARD: "guard",
    WAREHOUSE: "guard",
    DRIVER: "driver",
}
export const ZSHIP_ID = ["62f3e3529fbe010016c1f3d3", "635fa60add84ba00169a1a77"]
export const SUBMERCHANT_PRICING_METHODS = {
    piece: "PIECE",
    kg: "KILO"
}
export const ORDER_STATUS_VALUES = {
    created: "ORDER_CREATED",
    assigned: "ORDER_ASSIGNED",
    picked: "ORDER_PICKED",
    started: "ORDER_STARTED",
    completed: "ORDER_COMPLETED",
    failed: "ORDER_FAILED",
    failedToPickup: "ORDER_FAILED_TO_PICK_UP",
    failedToDropOff: "ORDER_FAILED_TO_DROP_OFF",
    pending: "ORDER_PENDING",
    rescheduleOrder: "ORDER_RESCHEDULED",
    returned: 'ORDER_RETURN',
    assignedForReturn: 'ORDER_ASSIGNED_TO_DRIVER_FOR_RETURN',
    pickedupForReturn: 'ORDER_PICKED_UP_FOR_RETURN'
}

export const API_LOADING_STATUSES = {
    idle: "idle",
    loading: "loading",
    succeeded: "succeeded",
    failed: "failed",
}

export const I18N_LANGUAGES = {
    ar: "ar-SA",
    en: "en-US"
}

export const SHIPPING_COMPANY_ORDERS_STATUS = {
    DELIVERY_REQUESTS: 'UNASSIGNED',
    // DELIVERY_REQUESTS: 'DELIVERY_REQUESTS',
    IN_TRANSIT_FROM_MERCHANT: 'IN_TRANSIT_FROM_MERCHANT',
    IN_TRANSIT_TO_SHIPPING_COMPANY: 'IN_TRANSIT_TO_SHIPPING_COMPANY',
    IN_SHIPPING_COMPANY_WHAREHOUSE: 'IN_SHIPPING_COMPANY_WHAREHOUSE',
    ORDER_ASSIGNED_TO_DRIVER: 'ORDER_ASSIGNED_TO_DRIVER',
    OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
    SUCCESSFUL: 'SUCCESSFUL',
    FAILED: 'FAILED',
}
export const MERCHANT_ORDERS_STATUS = {
    UNASSIGNED: "UNASSIGNED",
    ASSIGNED: "ASSIGNED",
    IN_TRANSIT: "IN_TRANSIT",
    SUCCESSFUL: "SUCCESSFUL",
    FAILED: "FAILED",
    ORDER_RESCHEDULED: "ORDER_RESCHEDULED",
    ORDER_RETURN: 'ORDER_RETURN',
    ORDER_ASSIGNED_TO_DRIVER_FOR_RETURN: 'ORDER_ASSIGNED_TO_DRIVER_FOR_RETURN',
    ORDER_PICKED_UP_FOR_RETURN: 'ORDER_PICKED_UP_FOR_RETURN'
}

export const TASK_STATUS = [
    { path: "tasks/zones", text: "Pick up requests", value: "TASK_CREATED" },
    { path: "tasks/zones", text: "Assined for Pickup", value: "TASK_ASSIGNED_TO_DRIVER_FOR_PICK_UP" },
    { path: "tasks/zones", text: "To warehouse", value: "TASK_PICKED_UP_FROM_MERCHANT" },
    { path: "tasks/warehouses", text: "In warehouse", value: "ORDER_IN_SHIPPING_COMPANY" },
    { path: "tasks/warehouses", text: "Out for delivery", value: "ORDER_PICKED_UP_FOR_DROP_OFF" },
    { path: "tasks/completed", text: "Failed tasks", value: "TASK_FAILED" },
    { path: "tasks/completed", text: "Successful tasks", value: "TASK_COMPLETED" },
    { path: "tasks/orders", text: "Failed orders", value: "ORDER_FAILED" },
]

export const FREELANCE_TASK_STATUS = [
    { path: "tasks/zones", text: "Tasks", value: "TASK_ASSIGNED_TO_DRIVER_FOR_PICK_UP" },
    { path: "tasks/zones", text: "Picked up", value: "TASK_PICKED_UP_FROM_MERCHANT" },
    { path: "tasks/orders", text: "Successful orders", value: "ORDER_COMPLETED" },
    { path: "tasks/orders", text: "Failed orders", value: "ORDER_FAILED" },
]

//================Filter status=======================

export const ORDER_FILTER_STATUS = [
    { text: "ORDER_PENDING", value: 'ORDER_PENDING' },
    { text: "ORDER_ASSIGNED_TO_SHIPPING_COMPANY", value: 'ORDER_ASSIGNED_TO_SHIPPING_COMPANY' },
    { text: "ORDER_ASSIGNED_TO_DRIVER_FOR_PICK_UP", value: 'ORDER_ASSIGNED_TO_DRIVER_FOR_PICK_UP' },
    { text: "ORDER_PICKED_UP_FROM_MERCHANT", value: 'ORDER_PICKED_UP_FROM_MERCHANT' },
    { text: "ORDER_IN_SHIPPING_COMPANY", value: 'ORDER_IN_SHIPPING_COMPANY' },
    { text: "ORDER_ASSIGNED_TO_DRIVER_FOR_DROP_OFF", value: 'ORDER_ASSIGNED_TO_DRIVER_FOR_DROP_OFF' },
    { text: "ORDER_PICKED_UP_FOR_DROP_OFF", value: 'ORDER_PICKED_UP_FOR_DROP_OFF' },
    { text: "ORDER_STARTED", value: 'ORDER_STARTED' },
    { text: "ORDER_COMPLETED", value: 'ORDER_COMPLETED' },
    { text: "ORDER_FAILED", value: 'ORDER_FAILED' },
    { text: "ORDER_ON_HOLD", value: 'ORDER_ON_HOLD' },
    { text: "ORDER_RESCHEDULED", value: 'ORDER_RESCHEDULED' },
    { text: "ORDER_RETURN", value: 'ORDER_RETURN' },
    { text: "ORDER_ASSIGNED_TO_DRIVER_FOR_RETURN", value: 'ORDER_ASSIGNED_TO_DRIVER_FOR_RETURN' },
    { text: "ORDER_PICKED_UP_FOR_RETURN", value: 'ORDER_PICKED_UP_FOR_RETURN' },
]
export const MERCHANT_ORDERS_ORDER_FILTER_STATUS = [
    { text: "ORDER_PENDING", value: 'ORDER_PENDING' },
    { text: "ORDER_ASSIGNED_TO_DRIVER_FOR_DROP_OFF", value: 'ORDER_ASSIGNED_TO_DRIVER_FOR_DROP_OFF' },
    { text: "ORDER_PICKED_UP_FOR_DROP_OFF", value: 'ORDER_PICKED_UP_FOR_DROP_OFF' },
    { text: "ORDER_STARTED", value: 'ORDER_STARTED' },
    { text: "ORDER_COMPLETED", value: 'ORDER_COMPLETED' },
    { text: "ORDER_FAILED", value: 'ORDER_FAILED' },
    { text: "ORDER_ON_HOLD", value: 'ORDER_ON_HOLD' },
    { text: "ORDER_RESCHEDULED", value: 'ORDER_RESCHEDULED' },
    { text: "ORDER_RETURN", value: 'ORDER_RETURN' },
    { text: "ORDER_ASSIGNED_TO_DRIVER_FOR_RETURN", value: 'ORDER_ASSIGNED_TO_DRIVER_FOR_RETURN' },
    { text: "ORDER_PICKED_UP_FOR_RETURN", value: 'ORDER_PICKED_UP_FOR_RETURN' },
]
export const FIRST_MILE_ORDERS_ORDER_FILTER_STATUS = [
    { text: "ORDER_PENDING", value: 'ORDER_PENDING' },
    { text: "ORDER_ASSIGNED_TO_DRIVER_FOR_PICK_UP", value: 'ORDER_ASSIGNED_TO_DRIVER_FOR_PICK_UP' },
    { text: "ORDER_PICKED_UP_FROM_MERCHANT", value: 'ORDER_PICKED_UP_FROM_MERCHANT' },
    { text: "In warehouse", value: 'ORDER_IN_SHIPPING_COMPANY' },
    { text: "ORDER_PICKED_UP_FOR_DROP_OFF", value: 'ORDER_PICKED_UP_FOR_DROP_OFF' },
    { text: "ORDER_FAILED", value: 'ORDER_FAILED' },
]
export const LAST_MILE_ORDERS_ORDER_FILTER_STATUS = [
    { text: "ORDER_IN_SHIPPING_COMPANY", value: 'ORDER_IN_SHIPPING_COMPANY' },
    { text: "ORDER_ASSIGNED_TO_DRIVER_FOR_DROP_OFF", value: 'ORDER_ASSIGNED_TO_DRIVER_FOR_DROP_OFF' },
    { text: "ORDER_PICKED_UP_FOR_DROP_OFF", value: 'ORDER_PICKED_UP_FOR_DROP_OFF' },
    { text: "ORDER_STARTED", value: 'ORDER_STARTED' },
    { text: "ORDER_COMPLETED", value: 'ORDER_COMPLETED' },
    { text: "ORDER_FAILED", value: 'ORDER_FAILED' },
    { text: "ORDER_ON_HOLD", value: 'ORDER_ON_HOLD' },
    { text: "ORDER_RESCHEDULED", value: 'ORDER_RESCHEDULED' },
]
export const FREELANCE_ORDERS_FILTER_STATUS = [
    { text: "Successful orders", value: "ORDER_COMPLETED" },
    { text: "Failed orders", value: "ORDER_FAILED" },
]

export const MERCHANT_TASK_STATUS_FILTER = [
    { text: "Pick up requests", value: 'TASK_CREATED' },
    { text: "Assigned for drop off", value: "TASK_ASSIGNED_TO_DRIVER_FOR_DROP_OFF" },
    { text: "Picked for drop off", value: "TASK_PICKED_UP_FOR_DROP_OFF" },
    { text: "Assigned for return", value: "TASK_ASSIGNED_TO_DRIVER_FOR_RETURN" },
    { text: "Picked for return", value: "TASK_PICKED_UP_FOR_RETURN" },
    { text: "Successful tasks", value: 'TASK_COMPLETED' },
    { text: "Failed tasks", value: 'TASK_FAILED' },
    { text: "Task started", value: 'TASK_STARTED' },
    { text: "Task holded", value: 'TASK_ON_HOLD' },
]

export const TASK_FILTER_STATUS = [
    { text: "Pick up requests", value: 'TASK_CREATED' },
    { text: "Assined for Pickup", value: 'TASK_ASSIGNED_TO_DRIVER_FOR_PICK_UP' },
    { text: "Task started", value: 'TASK_STARTED' },
    { text: "Task holded", value: 'TASK_ON_HOLD' },
    { text: "To warehouse", value: 'TASK_PICKED_UP_FROM_MERCHANT' },
    { text: "Successful tasks", value: "TASK_COMPLETED" },
    { text: "Failed tasks", value: "TASK_FAILED" },
]

export const FREELANCE_TASK_FILTER_STATUS = [
    { text: "Successful tasks", value: "TASK_COMPLETED" },
    { text: "Failed tasks", value: "TASK_FAILED" },
]




export function GET_ORDERS_STATUS(role) {
    if (role === ROLES.merchant) {
        return MERCHANT_ORDERS_STATUS
    } else if (role === ROLES.shippingCompany || role === USER_ROLES.MERCHANT) {
        return SHIPPING_COMPANY_ORDERS_STATUS
    } else {
        return {}
    }
}

// const ERROR_MESSEAGES = {
//     'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
//     'string.empty': `{#label} ${i18n.t("validationErrors.isEmpty")}`,
//     'number.base': `{#label} ${i18n.t("validationErrors.isNumber")}`,
//     'any.invalid': `{#label} ${i18n.t("validationErrors.notVaild")}`,
//     'email.invalid': `{#label} ${i18n.t("validationErrors.isEmail")}`,
//     'phoneNumber.invalid': `{#label} ${i18n.t("validationErrors.isValidPhone")}`,
//     'array.unique': `{#label} ${i18n.t("validationErrors.isUnique")}`,
// };

// export const ORDER_STATUS = [
//     {text:"Unassigned", value: "ORDER_PENDING" },
//     {text:"Assigned for shipping company", value: "ORDER_ASSIGNED_TO_SHIPPING_COMPANY" },
//     {text:"Assigned for pick up", value: "ORDER_ASSIGNED_TO_DRIVER_FOR_PICK_UP" },
//     {text:"Picked from merchant", value: "ORDER_PICKED_UP_FROM_MERCHANT" },
//     {text:"In shipping company warehouse", value: "ORDER_IN_SHIPPING_COMPANY" },
//     {text:"Assigned for drop off", value: "ORDER_ASSIGNED_TO_DRIVER_FOR_DROP_OFF" },
//     {text:"Picked for drop off", value: "ORDER_PICKED_UP_FOR_DROP_OFF" },
//     {text:"Started", value: "ORDER_STARTED" },
//     {text:"On hold", value: "ORDER_ON_HOLD" },
//     {text:"Completed", value: "ORDER_COMPLETED" },
//     {text:"Failed", value: "ORDER_FAILED" },
// ]
export const ORDER_STATUS = [
    "ORDER_PENDING",
    "ORDER_ASSIGNED_TO_SHIPPING_COMPANY",
    "ORDER_ASSIGNED_TO_DRIVER_FOR_PICK_UP",
    "ORDER_PICKED_UP_FROM_MERCHANT",
    "ORDER_IN_SHIPPING_COMPANY",
    "ORDER_ASSIGNED_TO_DRIVER_FOR_DROP_OFF",
    "ORDER_PICKED_UP_FOR_DROP_OFF",
    "ORDER_STARTED",
    "ORDER_ON_HOLD",
    "ORDER_COMPLETED",
    "ORDER_FAILED",
    "ORDER_RESCHEDULED"
]

export const HOTJAR_SETTINGS = {
    siteId: 3072337,
    hotjarVersion: 6
}

export const BLOG_POST_CHARACTER_LIMIT = 90

export const SHIPPING_COMPANY_TASK_STATUS_FILTER = [
    { text: "Pick up requests", value: 'TASK_CREATED' },
    { text: "Assined for Pickup", value: 'TASK_ASSIGNED_TO_DRIVER_FOR_PICK_UP' },
    { text: "To warehouse", value: 'TASK_PICKED_UP_FROM_MERCHANT' },
    { text: "Assigned for transfer", value: "TASK_ASSIGNED_TO_DRIVER_FOR_TRANSFER" },
    { text: "Picked for transfer", value: "TASK_PICKED_UP_FOR_TRANSFER" },
    { text: "Assigned for drop off", value: "TASK_ASSIGNED_TO_DRIVER_FOR_DROP_OFF" },
    { text: "Picked for drop off", value: "TASK_PICKED_UP_FOR_DROP_OFF" },
    { text: "Assigned for return", value: "TASK_ASSIGNED_TO_DRIVER_FOR_RETURN" },
    { text: "Picked for return", value: "TASK_PICKED_UP_FOR_RETURN" },
    { text: "Successful tasks", value: 'TASK_COMPLETED' },
    { text: "Failed tasks", value: 'TASK_FAILED' },
    { text: "Task started", value: 'TASK_STARTED' },
    { text: "Task holded", value: 'TASK_ON_HOLD' },
]
export const LAST_MILE_TASK_STATUS_FILTER = [
    { text: "Assigned for transfer", value: "TASK_ASSIGNED_TO_DRIVER_FOR_TRANSFER" },
    { text: "Picked for transfer", value: "TASK_PICKED_UP_FOR_TRANSFER" },
    { text: "Assigned for drop off", value: "TASK_ASSIGNED_TO_DRIVER_FOR_DROP_OFF" },
    { text: "Picked for drop off", value: "TASK_PICKED_UP_FOR_DROP_OFF" },
    { text: "Assigned for return", value: "TASK_ASSIGNED_TO_DRIVER_FOR_RETURN" },
    { text: "Picked for return", value: "TASK_PICKED_UP_FOR_RETURN" },
    { text: "Completed tasks", value: 'TASK_COMPLETED' },
    { text: "Task started", value: 'TASK_STARTED' },
    { text: "Task holded", value: 'TASK_ON_HOLD' },
]

export const SHIPPING_COMPANY_TASK_STATUS_NOT_EDITABLE = ["TASK_PICKED_UP_FROM_MERCHANT", "TASK_PICKED_UP_FOR_TRANSFER", "TASK_PICKED_UP_FOR_DROP_OFF", "TASK_PICKED_UP_FOR_RETURN", "TASK_COMPLETED", "TASK_FAILED", "TASK_STARTED", "TASK_ON_HOLD"]
export const ORDER_STATUS_NOT_EDITABLE = ["ORDER_PICKED_UP_FROM_MERCHANT", "ORDER_PICKED_UP_FOR_DROP_OFF", "ORDER_PICKED_UP_FOR_RETURN", "ORDER_COMPLETED", "ORDER_FAILED", "ORDER_FAILED_TO_PICK_UP", "ORDER_FAILED_TO_DROP_OFF"]

export const SERVICE_LEVELS = [
    { code: "level_1", name: "Now" },
    { code: "level_2", name: "Fast" },
    { code: "level_4", name: "No rush" },
    { code: "reverse", name: "Reversed Shipments" },
    { code: "aramex_drop_off", name: "Aramex Drop-off" },
    { code: "smsa_drop_off", name: "SMSA Drop-Off" },
    { code: "saudi_post_drop_off", name: "Saudi Post-Drop-Off" },
    { code: "aramex_gcc_drop_off", name: "Aramex GCC-Drop-off" },
]

//===============Plans===============
export const plan1 = [true, true, true, true, true, true, true, false, false, false, false, 90, 100, "Free"]
export const plan2 = [true, true, true, true, true, true, true, true, true, true, true, "Year", 2500, "Contact us"]
export const plan3 = [true, true, true, true, true, true, true, true, true, true, true, "Unlimited", 5000, "Contact us"]

export const FEDEX_IDS = ["64ae5fe37a26730014bab1f3", "64c82586c9b28c00149ec5c8"]

export const SURVEY = [
    { name: 'company_activity_type', content: "What is your type of activity?", required: true },
    { name: 'received_order', content: "How is the order received?", required: true },
    { name: 'payment', content: "How is payment made?", required: true },
    { name: 'assign_to_driver', content: "How are orders assigned to drivers (manually or automatically)?", required: true },
    { name: 'order_content', content: "Contents of the order (name, location, mobile number, quantity, weight, type, etc.)?", required: false },
    { name: 'systems_in_use', content: "Are there systems in use and what are they?", required: false },
    { name: 'reigons_neighborhoods', content: "Is the assignment based on regions or neighborhoods?", required: false },
    { name: 'communicating_with_customer', content: "How does the driver deal with orders, in terms of communicating with the customer or knowing the location?", required: false },
    { name: 'end_service', content: "How do I end the service, sign or confirm?", required: false },
    { name: 'challenges', content: "What are the most important challenges you face? (the customer’s location, assigning shipments to the driver, collecting payments, etc.)", required: false },
]

export const USER_ROLES = {
    MERCHANT: 'MERCHANT',
    WAREHOUSE: 'WAREHOUSE',
    DRIVER: 'DRIVER',
    ADMIN: 'ADMIN'
}

export const USER_ROLES_TYPES = {
    ADMIN: 'ADMIN',
    SUB_ADMIN: 'SUB_ADMIN',
    SUPERVISOR: 'SUPERVISOR',
    FREELANCE: 'FREELANCE'
}

export const USER_PERMISSIONS = {
    PICK_UP: 'PICK_UP',
    DROP_OFF: 'DROP_OFF'
}

export const OUT_SOURCE_COMPANY = [
    { name: "MOMENT" }
]

export const MOMENT_IDS = [
    "64fd85118c7b960014497aed", "62c407556f1a5d001601018d"
]

// export const IRONER_IDS = {
//     staging: {
//         IRONER_SHIPPING_COMPANY_ID: "66e17f023727ae0015e0e723",
//         IRONER_MERCHANT_ID: "66e186ef3727ae0015e0e820",
//     },
//     production: {
//         IRONER_SHIPPING_COMPANY_ID: "66fe95f73ad1150015adb43f",
//         IRONER_MERCHANT_ID: "66d47886a71ddb001518a5ec",
//     }
// }

export const IRONER = ["66e17f023727ae0015e0e723", "66fe95f73ad1150015adb43f", "66e186ef3727ae0015e0e820", "66d47886a71ddb001518a5ec"]

export const BLOG_POST_TYPES = {
    news: 'NEWS',
    articles: 'ARTICLES'
}

export const GOOGLE_STORAGE = "https://storage.googleapis.com/mapit-staging"

export const NUMERIC_REGEX = /^[0-9\u0660-\u0669]+$/;
export const ALPHANUMERIC_REGEX = /(^$)|(^[a-zA-Z0-9\u0621-\u064A\u0660-\u0669\s]+$)/;


export const TASK_TYPES = {
    pickup: "PICK_UP",
    dropoff: "DROP_OFF",
    transfer: "TRANSFER",
    returnTask: "RETURN",
    returnToShippingCompany: "RETURN_TO_SHIPPING_COMPANY",
    returnToMerchant: "RETURN_TO_MERCHANT"
}

export const RETURN_TASK_TYPES = [TASK_TYPES.returnTask, TASK_TYPES.returnToShippingCompany, TASK_TYPES.returnToMerchant]

export const TAP_TRANSACTION_STATUS = {
    initiated: "INITIATED", //xx
    inProgress: "IN_PROGRESS", //xx
    pending: "PENDING", // ok
    paid: "PAID", // ok
    failed: "FAILED", // ok
    canceled: "CANCELED", // ok
    expired: "EXPIRED", //xx
    abandoned: "ABANDONED",
    declined: "DECLINED",
    restricted: "RESTRICTED",
    void: "VOID",
    timedOut: "TIMEDOUT",
    deferred: "DEFERRED",
    unknown: "UNKNOWN",
}

export const notificationRead = {
    READ: 'READ',
    UNREAD: 'UNREAD ',
    CLICKED: 'CLICKED'
}

export const NoteTargetType = {
    MERCHANT: 'Merchant',
    FREEDEMO: 'freeDemo',
    CONTACTUS: 'contactUs',
    CODTRANSACTION:"codTransaction"
}

export const AccountStatus = {
    ACTIVE: 'ACTIVE',
    BLOCKED: 'BLOCKED',
    WAITING: 'WAITING',
}

export const PLANS_FEATURES = [
    "pricing.common.api",
    "pricing.common.thridParty",
    "pricing.common.geotagging",
    "pricing.common.userTracking",
    "pricing.common.podCode",
    "pricing.common.areaBasedSorting",
    "pricing.common.driverApplication",
    "pricing.common.autoAssignment",
    "pricing.common.routeOptimization",
    "pricing.common.eta",
    "pricing.common.barcode",
    "pricing.common.driverTracking",
]

export const ALL_FAILED_ORDER_STATUS = ["ORDER_FAILED", "ORDER_FAILED_TO_PICK_UP", "ORDER_FAILED_TO_DROP_OFF"]

export const ENAAB_ID = ["68151e8a2b5889001575c834", "6776c9596e67c200153afeec"]

export const ENAAB_ID_MAPIT_SHIP = ["6a312f397fea4b0002cda8d9" , "6a097fd22299da0002c9e929"]
